import type { IconProps } from "@phosphor-icons/react";
import { BowlFood, Heart, Moon, PersonSimpleWalk, Wind } from "@phosphor-icons/react";
import type { SnapshotBehaviourMeta } from "./snapshot-tokens";

export function BehaviourIcon({
  name,
  ...rest
}: { name: SnapshotBehaviourMeta["iconName"] } & IconProps) {
  switch (name) {
    case "moon":
      return <Moon {...rest} />;
    case "bowl-food":
      return <BowlFood {...rest} />;
    case "person-simple-walk":
      return <PersonSimpleWalk {...rest} />;
    case "wind":
      return <Wind {...rest} />;
    case "heart":
      return <Heart {...rest} />;
  }
}
